import makePlural from "../makePlural";
import makeSingular from "../makeSingular";
import { NEW_LINE, TAB_SPACE } from "./constants";
import getReduxTypesImports from "./getReduxTypesImports";

export default function getReduxReducers(params) {
  const singularModuleName = makeSingular(params.module);

  return (
    // Start import **
    `import {${
      NEW_LINE + TAB_SPACE + getReduxTypesImports(params).join(NEW_LINE + TAB_SPACE) + NEW_LINE
    }} from './${singularModuleName.toLowerCase()}Types';` +
    // ** End import
    NEW_LINE +
    NEW_LINE +
    // Start init states **
    `const initialState = {${NEW_LINE + TAB_SPACE}loading: false,${NEW_LINE + TAB_SPACE}error: '',${NEW_LINE}};` +
    // ** End init states
    NEW_LINE +
    NEW_LINE +
    `const ${singularModuleName.toLowerCase()}Reducer = (state = initialState, action) => {` +
    `${NEW_LINE + TAB_SPACE}switch (action.type) {` +
    (params?.features === "rw" || params?.features === "r" ? getReduxReadReducers(params.module) : "") +
    (params?.features === "rw" || params?.features === "w" ? getReduxWriteReducers(params.module) : "") +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}default:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return state;` +
    `${NEW_LINE + TAB_SPACE}}` +
    `${NEW_LINE}};` +
    NEW_LINE +
    NEW_LINE +
    `export default ${singularModuleName.toLowerCase()}Reducer;`
  );
}

function getReduxReadReducers(module) {
  const pruralModuleName = makePlural(module).toUpperCase();
  const singularModuleName = makeSingular(module).toUpperCase();

  return (
    // fetch all request
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case FETCH_All_${pruralModuleName}_REQUEST:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: true,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // Fetch all success
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case FETCH_All_${pruralModuleName}_SUCCESS:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: false,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE + pruralModuleName.toLowerCase()}: action.payload,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}error: '',` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // Fetch all failure
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case FETCH_All_${pruralModuleName}_FAILURE:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: false,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE + pruralModuleName.toLowerCase()}: [],` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}error: action.payload,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // fetch single request
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case FETCH_SINGLE_${singularModuleName}_REQUEST:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: true,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // Fetch single success
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case FETCH_SINGLE_${singularModuleName}_SUCCESS:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: false,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE + singularModuleName.toLowerCase()}: action.payload,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}error: '',` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // Fetch single failure
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case FETCH_SINGLE_${singularModuleName}_FAILURE:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: false,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE + singularModuleName.toLowerCase()}: null,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}error: action.payload,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};`
  );
}

function getReduxWriteReducers(module) {
  const singularModuleName = makeSingular(module).toUpperCase();

  return (
    // create request
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case CREATE_${singularModuleName}_REQUEST:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: true,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // create success
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case CREATE_${singularModuleName}_SUCCESS:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: false,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}message: action.payload,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}error: '',` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // create failure
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case CREATE_${singularModuleName}_FAILURE:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: false,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}error: action.payload,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // update request
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case UPDATE_${singularModuleName}_REQUEST:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: true,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // update success
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case UPDATE_${singularModuleName}_SUCCESS:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: false,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}message: action.payload,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}error: '',` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // update failure
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case UPDATE_${singularModuleName}_FAILURE:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: false,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}error: action.payload,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // delete request
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case DELETE_${singularModuleName}_REQUEST:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: true,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // delete success
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case DELETE_${singularModuleName}_SUCCESS:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: false,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}message: action.payload,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}error: '',` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};` +
    // delete failure
    `${NEW_LINE + TAB_SPACE + TAB_SPACE}case DELETE_${singularModuleName}_FAILURE:` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}return {` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}...state,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}loading: false,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}error: action.payload,` +
    `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}};`
  );
}
